var _style, _path, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "refresh",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    #refresh:hover {animation: refresh 1s}\r\n    @keyframes refresh {to {transform: rotate(360deg)}}\r\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M561.7,320c0,133.5-108.2,241.7-241.7,241.7S78.3,453.5,78.3,320S186.5,78.3,320,78.3c95.2,0,177.6,55,217,135"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "429.2,217.8 545.9,217.8 545.9,102.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.b1a691e0a53448cf50023dc2a07aeea7.svg";
export { ForwardRef as ReactComponent };